import { render } from "./Journalism.vue?vue&type=template&id=e1c9dc3e&ts=true"
import script from "./Journalism.vue?vue&type=script&lang=ts"
export * from "./Journalism.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/jiangshanwen/workspace/website-3.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__